import { render, staticRenderFns } from "./SideMenubar.vue?vue&type=template&id=1375f07d"
import script from "./SideMenubar.vue?vue&type=script&lang=js"
export * from "./SideMenubar.vue?vue&type=script&lang=js"
import style0 from "./SideMenubar.vue?vue&type=style&index=0&id=1375f07d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports